var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimer16Px = function SvgTimer16Px(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 1H6v1.333h4zM7.333 9.667h1.334v-4H7.333zm5.354-4.407.946-.947c-.286-.34-.6-.66-.94-.94l-.946.947A5.98 5.98 0 0 0 8 3a6 6 0 1 0 6 6 5.98 5.98 0 0 0-1.313-3.74M8 13.667A4.663 4.663 0 0 1 3.333 9 4.663 4.663 0 0 1 8 4.333 4.663 4.663 0 0 1 12.667 9 4.663 4.663 0 0 1 8 13.667"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimer16Px);
export { ForwardRef as Icon };
export default "img/compound/timer-16px.11c8f82.svg";